<template>
    <div>
        <highcharts :options="chartOptions" :constructorType="constructorType"></highcharts>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

Highcharts.setOptions({
  global: {
    useUTC: false // Fixes issue with tooltips on charts for some reason.
  }
});

exportingInit(Highcharts)
import xrange from 'highcharts/modules/xrange';
import dumbbell from 'highcharts/modules/dumbbell';
import timeline from 'highcharts/modules/timeline';
import streamgraph from 'highcharts/modules/streamgraph';
import wordcloud from 'highcharts/modules/wordcloud';
import More from 'highcharts/highcharts-more';
import annotations from 'highcharts/modules/annotations';
import sankey from 'highcharts/modules/sankey';

More(Highcharts);
xrange(Highcharts);
dumbbell(Highcharts);
timeline(Highcharts);
streamgraph(Highcharts);
wordcloud(Highcharts);
annotations(Highcharts);
sankey(Highcharts);

require('highcharts-custom-events')(Highcharts);

export default {
    props: ['chartData', 'constructorType'],
    components: {
        highcharts: Chart 
    },
    computed: {
        chartOptions() {
        return {
                yAxis: {
                    min: 0
                },
                plotOptions: {
                    series: {
                        stacking: 'normal'
                    }
                },
                credits: {
                    enabled: false
                }
            ,...this.chartData
            }
        }
    }
}
</script>